"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("el-form", [_c("el-form-item", {
    attrs: {
      label: "Name"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.formData.fullName,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "fullName", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "formData.fullName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Email"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.formData.emailAddress,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "emailAddress", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "formData.emailAddress"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Mobile Number",
      prop: "mobileNumber"
    }
  }, [_c("el-input", {
    attrs: {
      name: "mobileNumber",
      placeholder: "Mobile Number"
    },
    model: {
      value: _vm.formData.mobileNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "mobileNumber", $$v);
      },
      expression: "formData.mobileNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Avatar",
      prop: "formData.avatar"
    }
  }, [_c("file-upload", {
    attrs: {
      "file-list": _vm.avatar
    },
    on: {
      change: _vm.fileUploaded
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v(" Update ")])], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;